import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Add auth token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tapisstore_admin_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401 : nettoie le token et redirige vers la page de connexion admin
api.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error.response?.status;
    const config = error.config;

    // 401/403 → redirection vers login
    if (status === 401 || status === 403) {
      localStorage.removeItem('tapisstore_admin_token');
      localStorage.removeItem('tapisstore_admin_email');
      if (window.location.pathname.startsWith('/admin') && window.location.pathname !== '/admin') {
        window.location.href = '/admin';
      }
      return Promise.reject(error);
    }

    // Erreurs serveur (5xx) ou réseau → 1 retry automatique après 2 secondes
    const isServerError = !status || status >= 500;
    if (isServerError && !config._retried) {
      config._retried = true;
      await new Promise(res => setTimeout(res, 2000));
      return api(config);
    }

    return Promise.reject(error);
  }
);

// File upload (multipart)
export const uploadImage = (formData) =>
  api.post('/upload', formData, { headers: { 'Content-Type': 'multipart/form-data' } });

// CMS
export const getCMSContent = () => api.get('/cms');
export const getAdminCMSFull = () => api.get('/admin/cms');
export const updateCMSContent = (items) => api.put('/admin/cms', { items });

// Categories
export const getCategories = () => api.get('/categories');
export const getCategory = (id) => api.get(`/categories/${id}`);
export const createCategory = (data) => api.post('/categories', data);
export const updateCategory = (id, data) => api.put(`/categories/${id}`, data);
export const deleteCategory = (id) => api.delete(`/categories/${id}`);

// Products
export const getProducts = (params) => api.get('/products', { params });
export const getProduct = (id) => api.get(`/products/${id}`);
export const getProductBySlug = (slug) => api.get(`/products/slug/${slug}`);
export const createProduct = (data) => api.post('/products', data);
export const updateProduct = (id, data) => api.put(`/products/${id}`, data);
export const deleteProduct = (id) => api.delete(`/products/${id}`);

// Orders
export const createOrder = (data) => api.post('/orders', data);
export const getOrders = () => api.get('/orders');
export const getOrder = (id) => api.get(`/orders/${id}`);
export const getOrderById = (id) => api.get(`/orders/${id}`);
export const updateOrderStatus = (id, status) => api.put(`/orders/${id}/status?status=${status}`);
export const setOrderTracking = (id, data) => api.put(`/admin/orders/${id}/tracking`, data);
export const deleteOrder = (id) => api.delete(`/orders/${id}`);

// Checkout
export const createCheckoutSession = (data) => api.post('/checkout/create-session', data);
export const getCheckoutStatus = (sessionId) => api.get(`/checkout/status/${sessionId}`);

// Auth
export const adminLogin = (data) => api.post('/auth/login', data);

// Stats
export const getAdminStats = () => api.get('/admin/stats');
export const getAdminSetupStatus = () => api.get('/admin/setup-status');

// Media library
export const getMediaList = () => api.get('/admin/media');
export const deleteMedia = (imageId) => api.delete(`/admin/media/${imageId}`);

// Blog
export const getBlogArticles = () => api.get('/blog/articles');

export default api;
